import React, { Component, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Rollbar from 'mangools-commons/dist/configs/rollbar';

type ModalErrorBoundaryProps = {
  children: ReactNode | ReactNode[];
};

type ModalErrorBoundaryState = {
  hasError: boolean;
};

// Keeps a rendering error inside the modal content instead of letting it bubble up to the
// route boundary and blank the whole page. The modal chrome (close button, backdrop click)
// is rendered by MessageHolder around this component, so it keeps working after a failure
// and the user can close the window and continue.
class ModalErrorBoundary extends Component<ModalErrorBoundaryProps, ModalErrorBoundaryState> {
  state: ModalErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ModalErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    Rollbar.error(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="mg-alert is-error mg-margin-0">
          <FontAwesomeIcon icon="exclamation-circle" className="mg-margin-r-5" aria-hidden="true" />
          Something went wrong. Please close this window and try again.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ModalErrorBoundary;
